import { Card } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface MetricsCardProps {
  title: string;
  value: string | number;
  trend?: string;
  trendDirection?: 'up' | 'down' | 'neutral';
  status?: 'success' | 'warning' | 'error' | 'info';
  subtitle?: string;
  icon?: React.ReactNode;
}

const statusColors = {
  success: "text-green-600 bg-green-50 border-green-200",
  warning: "text-yellow-600 bg-yellow-50 border-yellow-200",
  error: "text-red-600 bg-red-50 border-red-200",
  info: "text-blue-600 bg-blue-50 border-blue-200"
};

const trendColors = {
  up: "text-green-600",
  down: "text-red-600",
  neutral: "text-gray-500"
};

export default function MetricsCard({
  title,
  value,
  trend,
  trendDirection = 'neutral',
  status = 'info',
  subtitle,
  icon
}: MetricsCardProps) {
  const TrendIcon = trendDirection === 'up' ? TrendingUp :
                   trendDirection === 'down' ? TrendingDown : Minus;

  return (
    <Card className={`p-4 border-l-4 ${statusColors[status]}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            {icon && <div className="text-gray-500">{icon}</div>}
            <p className="text-sm font-medium text-gray-600">{title}</p>
          </div>

          <div className="flex items-baseline gap-2">
            <p className="text-2xl font-bold text-gray-900">
              {typeof value === 'number' ? value.toLocaleString() : value}
            </p>

            {trend && (
              <div className={`flex items-center gap-1 ${trendColors[trendDirection]}`}>
                <TrendIcon className="h-3 w-3" />
                <span className="text-xs font-medium">{trend}</span>
              </div>
            )}
          </div>

          {subtitle && (
            <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
    </Card>
  );
}